import './utils/polyfill/Intl'

import { Sentry } from './utils/error-handling'

Sentry.init()

import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { ApiProvider } from './api/react-query'
import { FastTrackApi } from './providers/api-provider'
import { queryClient } from './providers/query-client'
import { routeTree } from './routeTree.gen'

const api = new FastTrackApi()

const router = createRouter({
	routeTree,
	context: { queryClient, api },
	defaultPreload: 'intent'
})

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement)
	root.render(
		<StrictMode>
			<ApiProvider api={api}>
				<RouterProvider router={router} />
			</ApiProvider>
		</StrictMode>
	)
}
